export const SITE_NAME = 'IKON Examen'

export const ASSESSMENT_NAME = 'The IKON Examen'

export const ASSESSMENT_NAME_SHORT = 'IKON Examen'

export const ASSESSMENT_WELCOME_TITLE = `Welcome to ${ASSESSMENT_NAME}`
